const globalStyleId = 'gs-text-main';
const defaultSelector = {
  selector: '#{eID} .gf_dropdown',
};
export default {
  defaultClass: 'gf_gs-text-paragraph-1',
  settingGroups: {
    [globalStyleId]: {
      fontWeight: {
        ...defaultSelector,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'font-size': {
        ...defaultSelector,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },

      font: {
        ...defaultSelector,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
      // "text-color": {
      //   ...defaultSelector,
      //   inherit: "text.fontColor",
      //   cssAttr: "color"
      // }
    },
  },
};

export const DROPDOWN_SETTING = [
  {
    gsId: globalStyleId,
    gsSettingGroup: 'Typography',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'paragraph',
  },
];
